import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { TextLink } from '@/components/TextLink';
import { colors } from '@/styles/colors';
import { ROUTES, EXTERNAL_URLS } from '@/utils/constants';

interface AuthFooterProps {
  variant: 'login' | 'forgot-password' | 'sso';
  onBackToLogin?: () => void;
  onSSOClick?: () => void;
  onForgotPassword?: () => void;
  showSSO?: boolean;
}

export const AuthFooter: React.FC<AuthFooterProps> = ({ 
  variant, 
  onBackToLogin,
  onSSOClick,
  onForgotPassword,
  showSSO = true,
}) => {
  const router = useRouter();

  return (
    <View style={styles.container}>
      {/* Contextual Links based on screen */}
      {variant === 'login' && (
        <>
          <TextLink
            href={ROUTES.FORGOT_PASSWORD}
            onPress={() => router.push(ROUTES.FORGOT_PASSWORD)}
          >
            Forgot email or password?
          </TextLink>

          {showSSO && (
            <TextLink
              href="#sso-login"
              onPress={onSSOClick}
            >
              Sign in with SSO
            </TextLink>
          )}
        </>
      )}

      {variant === 'forgot-password' && (
        <>
          <TextLink
            href={ROUTES.LOGIN}
            onPress={onBackToLogin}
          >
            Back to login
          </TextLink>

          {showSSO && (
            <TextLink
              href="#sso-login"
              onPress={onSSOClick}
            >
              Sign in with SSO
            </TextLink>
          )}
        </>
      )}

      {variant === 'sso' && (
        <>
          <TextLink
            href={ROUTES.LOGIN}
            onPress={onBackToLogin}
          >
            Back to login
          </TextLink>

          <TextLink
            href={ROUTES.FORGOT_PASSWORD}
            onPress={onForgotPassword}
          >
            Forgot email or password?
          </TextLink>
        </>
      )}

      {/* Common: "Don't have an account? Sign up" - Always shown */}
      <View style={styles.signupNote}>
        <Text style={styles.signupText}>Don't have an account? </Text>
        <TextLink href={EXTERNAL_URLS.ONBOARDING}>Sign up</TextLink>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 24,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
  },
  signupNote: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 24,
  },
  signupText: {
    fontSize: 14,
    color: colors.textPrimary,
  },
});
